import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { EndOfJourneyTemplate } from '../../lib/types/models/end-of-journey-template/end-of-journey-template'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEndOfJourneyTemplates(input?: PaginationRequest) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API['end-of-journey-templates'].getAll.url, null), input)
    )
    .get<PaginationResponse<EndOfJourneyTemplate>>()
}
